export const slugify = (value = '') =>
    String(value)
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

export const buildPackageUrl = (pkgOrId, title) => {
    const id = typeof pkgOrId === 'object' ? pkgOrId?.id : pkgOrId;
    const packageTitle = typeof pkgOrId === 'object' ? pkgOrId?.title : title;
    const slug = slugify(packageTitle || 'package');

    return `/package/${id}/${slug}`;
};
